import { Action } from 'redux';

import {
    CSIActionType,
    CSISetCommentAction,
    CSISetDislikesAction,
    CSISetLikesAction,
    CSISetRatingAction,
    CSISetRejectedAction,
    SetCsiStateAction,
    SetCSIVisibleAction,
} from './csi.actions';

const initialState = {
    rating: 0,
    likes: [] as string[],
    dislikes: [] as string[],
    comment: '',
    rejected: false,
    ratingSent: false,
    hasBeenRead: false,
    wasReceived: false,
    isVisible: false,
};

export type CsiState = typeof initialState;

export const csiReducer = (
    state = initialState,
    action: Action<CSIActionType>,
): typeof initialState => {
    switch (action.type) {
        case CSIActionType.SetRating:
            const rating = (action as CSISetRatingAction).payload;
            return {
                ...state,
                rating,
            };

        case CSIActionType.SetLikes:
            const likes = (action as CSISetLikesAction).payload;
            return {
                ...state,
                likes,
            };

        case CSIActionType.SetDislikes:
            const dislikes = (action as CSISetDislikesAction).payload;
            return {
                ...state,
                dislikes,
            };

        case CSIActionType.SetComment:
            const comment = (action as CSISetCommentAction).payload;
            return {
                ...state,
                comment,
            };
        case CSIActionType.setCsiState:
            const { payload } = action as SetCsiStateAction;
            return {
                ...state,
                ...payload,
            };

        case CSIActionType.SetRejected:
            const rejected = (action as CSISetRejectedAction).payload;
            return {
                ...state,
                rejected,
            };
        case CSIActionType.SetCSIVisible:
            const isVisible = (action as SetCSIVisibleAction).payload;
            return {
                ...state,
                isVisible,
            };
        case CSIActionType.Send:
            return {
                ...state,
                ratingSent: true,
            };

        case CSIActionType.Reset:
            return initialState;

        default:
            return state;
    }
};
